import { useTranslation } from 'react-i18next'
import { RegisterForm } from '@/features/auth/components/RegisterForm'

export function RegisterPage() {
  const { t } = useTranslation()

  return (
    <main className="min-h-screen bg-surface-50 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <h1 className="text-2xl font-semibold text-surface-900 mb-8 text-center">
          {t('auth.register_title')}
        </h1>
        <RegisterForm />
      </div>
    </main>
  )
}
